<div class='transactionInfo'>
    <div class="st-headTitle-wraper">
        <headTitle [text]="meS.OFFICIAL ? 'My Wallet' : 'Assignor Fees'" svgLeft='arrow_squareLeft&24'
            (svgLeftEmit)='goBack()' typeText='text1-blueDark'>
        </headTitle>

    </div>
    <div class="transactionInfoSub">
        <div class="page-header">
            <div>
                <div class="amount-name">Amount</div>
                <span class="transaction-amount">
                {{ gameData?.gameId ? '' : '-' }}{{ gameData?.totalInCents   | currency: 'USD'}}
                </span>
                <ng-container *ngIf="!gameData?.gameId && gameData?.description as desc">
                    <div *ngIf="desc.length >= 2" class="amount-description">
                      {{ globalConst.formatDescriptionLineSpace(desc[0]) }} | {{ globalConst.formatDescriptionLineSpace(desc[1]) }}
                    </div>
                  </ng-container>
                <div class="status">
                    <status [status]="gameData?.overallTransfersStatus"></status>
                </div>

            </div>
        </div>

        <div class="infoTitle">
            <div>Transaction Information</div>
        </div>

        <div class="content">
            <div class='t-table-v2 game-information'  *ngIf="isNotPaidOrIntransit()" style="height: fit-content;">
                <div class='t-table-v2__item-two'>
                    <div class='cell-header st-600'>Game#</div>
                    <div>{{gameData?.gameNumber}}</div>
                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>Game Date</div>
                    <div>{{gameData?.gameDate | date: globalConst.dateFormat}}</div>
                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'> Competition</div>
                    <div>{{gameData?.competitionName}}</div>
                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>Role</div>
                    <div>{{gameData?.role}}</div>
                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>Age & Level</div>
                    <div>{{gameData?.gameAgeDescription}} - {{gameData?.competitionLevel}}</div>
                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>Game Type</div>
                    <div>{{ globalConst.formatDescriptionLineSpace(gameData?.gameType ?? '') }}</div>

                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>Transaction Date</div>
                    <div>{{ globalConst.formatToEST( gameData?.transactionDate) }}</div>
                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>Assignor</div>
                    <div>{{gameData?.assignorName}}</div>
                </div>
            </div>
            <div class='t-table-v2 game-information'  *ngIf="!isNotPaidOrIntransit()" style="height: fit-content;">
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>Amount</div>
                    <div>{{ gameData?.totalInCents  | currency: 'USD' }}</div>
                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>Fee</div>
                    <div>{{ gameData?.notchPayFeeInCents  | currency: 'USD' }}</div>
                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>To</div>
                    <div>{{ globalConst.formatDescriptionLineSpace(gameData?.payoutDestination ?? '') }}</div>
                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>Status</div>
                    <div>{{ globalConst.formatDescriptionLineSpace(gameData?.overallTransfersStatus ?? '') }}</div>
                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>Initiated</div>
                    <div>{{ globalConst.formatToEST( gameData?.transactionDate) }}</div>
                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>Est. Arrival</div>
                    <div>{{ globalConst.formatToEST(gameData?.estimatedArrival) }}</div>
                </div>
                <div class='t-table-v2__item-two'>
                    <div class='cell-header  st-600'>Last Updated</div>
                    <div>{{ globalConst.formatToEST(gameData?.lastUpdated ) }}</div>
                </div>
            </div>

        </div>
    </div>
</div>